import React from "react";
import { Link } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import PageHero from "./PageHero";

// The layout shared by the Privacy Policy and the Terms and Conditions:
// a banner, then the text. Put the text of the page between the tags.
//   other: { to, label } - the other legal page, linked at the bottom
function LegalPage({ title, intro, other, children }) {
    return (
        <div className="cf-public">
            <Header />
            <main>
                <PageHero eyebrow="Legal" title={title}>{intro}</PageHero>

                <section className="cf-sec cf-legal-sec">
                    <div className="cf-wrap">
                        <div className="cf-legal">
                            {children}

                            <p className="cf-legal-other">
                                See also the <Link to={other.to}>{other.label}</Link>.
                            </p>
                        </div>
                    </div>
                </section>
            </main>
            <Footer />
        </div>
    );
}

export default LegalPage;
